module.exports = __webpack_public_path__ + "static/media/visa.e72424dd.png";